import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";

import { TrialBannerPropTypes } from "../lib/types";

import styled from "styled-components";
import { redesignTheme } from "../../../theme/theme";
import { format, parseISO } from "date-fns";

const celebrationOutline = require("../../../svg/celebrationPartyPopperOutline.svg");

const StyledImg = styled.img`
  margin-right: ${redesignTheme.spacing[2.5]};
`;

const StyledBannerContainer = styled.div`
  background: ${redesignTheme.color.green50};
  padding: ${redesignTheme.spacing[4]} ${redesignTheme.spacing[6]};
  border-radius: ${redesignTheme.radius.lg};
  display: flex;
  justify-content: space-between;
  margin-bottom: ${redesignTheme.spacing[6]};
`;

export const StyledBannerText = styled.p`
  font-family: ${redesignTheme.fontFamily.interface};
  font-size: ${redesignTheme.fontSize[100]};
  line-height: 24px;
  font-weight: ${redesignTheme.fontWeight.normal};
  margin: 0;
  display: block;
`;

const TrialBanner = ({
  trialEndDate,
}: TrialBannerPropTypes): React.ReactElement => {
  return (
    <StyledBannerContainer data-testid="trial-banner">
      <div style={{ display: "flex" }}>
        <StyledImg src={celebrationOutline} />
        <StyledBannerText
          dangerouslySetInnerHTML={{
            __html: i18n.translate(
              "admin_pages.settings.banner.trial_start_info_date",
              {
                startDate: format(parseISO(trialEndDate), "eeee, MMMM dd yyyy"),
              }
            ),
          }}
        />
      </div>
    </StyledBannerContainer>
  );
};

export default TrialBanner;
